// WIP - this is not a full type definition
// add more as needed

import { User } from 'Shared/constants/types';
import { CalendarMeeting } from './CalendarMeeting.type';
import type { BotAttributes } from './MeetingTranscriptions.type';

export enum TemplateWizardStateType {
  INITIALIZED = 'initialized',
  COMPLETED = 'completed',
}

export type MeetingModeSession = {
  id: number;
  active: boolean;
  participantIds: number[];
  state: string;
  workspaceItemId?: number;
  workspaceItemUuid?: string;
  numSteps?: number;
  stepIndex?: number;
  seenWorkspaceItemIds: number[];
  seenWorkspaceItemIdsInNavigationalOrder?: number[];
  createdAt: string;
  workspaceSlug: string;
  typingParticipants: Record<string, number | null>;
  isLastAgendaItem: boolean;
};

export type RecurringMeeting = {
  name: string;
  htmlLink?: string;
  nextEventDate?: string;
  cancelled: boolean;
  conferenceUrl?: string;
  source: number;
  frequency?: string;
  nextEventHtmlLink?: string;
  hasWorkspace: boolean;
  suggestedWorkspaceId?: number;
};

export type Workspace = {
  id: string;
  name: string;
  description: string;
  isPersonal: boolean;
  isGroup: boolean;
  isOneOnOne: boolean;
  isTeamSync: boolean;
  shareLink: string;
  users: User[];
  path: string;
  presenceData: any; // This needs to be typed correctly
  loading: boolean;
  recurringMeeting?: RecurringMeeting;
  calendarMeeting?: CalendarMeeting;
  attendeesWithoutAccounts?: Array<any>;
  initialTemplateSelectionMade: boolean;
  templateWizardState: string;
  templateWizardInitiatorSlug: string;
  workspaceAiSettings: any;
  inviteTeammateSuggestion: any;
  slackAiOrganizationDataSource: {
    data: {
      id?: string;
    };
  };
  // should of a type work workspace meeting item
  discussion_topics: Array<any>;
  meeting_items: Array<any>;
  meetingModeSession?: MeetingModeSession;
  workspaceNotifications: {
    count: number;
    modifiedItemsUuids: string[];
    modifiedCommentsUuids: string[];
    viewedWorkspace: boolean;
    viewedWorkspaceTime: string | null;
  };
  recurrence?: {
    nextRunAt?: string;
  };
  manualNextEventDate?: string;
  lastMeetingTranscription?: BotAttributes;
};
